'use client'

import { FC, ReactElement, ReactNode } from 'react'
import { Tooltip, TooltipProps } from './tooltip'
import { TooltipContent } from './tooltip-content'
import { TooltipTrigger } from './tooltip-trigger'
import { TooltipArrow } from './tooltip-arrow'

export interface SimpleTooltipProps extends TooltipProps {
  children: ReactElement<$TSFixMe>
  content: ReactNode
  asChild?: boolean
}

export const SimpleTooltip: FC<SimpleTooltipProps> = ({
  children,
  content,
  asChild = true,
  ...rest
}) => {
  return (
    <Tooltip {...rest}>
      <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
      <TooltipContent>
        <TooltipArrow />
        {content}
      </TooltipContent>
    </Tooltip>
  )
}
